const $ = jQuery.noConflict();

'use strict';
const FormHelpers = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	strCF7Holder: '.js-cf7-holder',
	strForm: '.wpcf7-form',
	strTriggerURL: '#wpcf7-f17-o1',
	classSent: 'form-is-sent',
	classInvalid: 'invalid',
	activeCanvas: false,
	thankYouUrls: {},
	formSubmitted: false,

	/** @description Initialize */
	init: function() {
		this.clearCanvas();
		this.checkIfIE();
		this.afterFormSubmit();
		this.bindEvents();
		this.titlePlacement();
		this.mailchimpScroll();
		this.checkCanvasMovement();
		this.customFile();
		this.getThankYouUrls();
	},

	/**
	 * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
	 * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
	 * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
	 * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
	 * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
	 */

	bindEvents: function() {
		$('form.wpcf7-form').on('submit', function() {
			const form = $(this);
			const button = form.find('input[type=submit]');
			const currentVal = button.val();
			// store the current value so we can reset it later
			button.attr('data-value', currentVal);
			// disable the button
			button.prop('disabled', true);

			$('.js-accordion-item').removeClass('active-error');

		});
		$('.wpcf7').on('wpcf7invalid', function() {
			$('form.wpcf7-form').find('input[type=submit]').prop('disabled', false);

			setTimeout(() => {
				$('.js-select-cf7~.wpcf7-not-valid-tip').text('Please select the option');
			}, 0);

			// Check to see dropdown includes any invalid fields
			if ($('.js-accordion-item').length) {
				setTimeout(() => {
					$('.js-accordion-item .wpcf7-not-valid').each(function() {
						$(this).closest('.js-accordion-item').addClass('active-error');
					});
				}, 0);
			}

			//check to see if canvas is empty
			if ($('.signature-821').length) {
				setTimeout(() => {
					if (FormHelpers.isCanvasEmpty($('.signature-821')[0])) {
						$('.js-cf7-sign-error').addClass('not-active');
					}
				}, 0);
			}

			//scroll to error fields
			setTimeout(() => {
				FormHelpers.errorScroll();
			}, 0);

			//check form is already submitted once
			if ($('.signature-821').length && !FormHelpers.formSubmitted) {
				$('.wpcf7-submit').trigger('click');
				FormHelpers.formSubmitted = true;
			}
		});

		$('.wpcf7').on('wpcf7mailsent', function() {
			$('form.wpcf7-form').find('input[type=submit]').prop('disabled', false);
		});
	},


	afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent', delay = 5000) => {
		document.addEventListener('wpcf7mailsent', (e) => {
			const formId = `#${e.detail.unitTag}`;
			const cf7Id = e.detail.contactFormId;

			$(formId).parents(formHolder).addClass(sentClass);
			$('.js-select-cf7 option:first-child').attr('disabled', false);
			$('.js-select-cf7').val('').trigger('change');
			$('.js-select-cf7').removeClass('selected');
			$('.js-upload-label').text('Select or drop a file');
			$('.js-upload-label').removeClass('changed');

			//check to see if canvas is empty
			if ($('.signature-821').length) {
				$('.js-cf7-sign-error').addClass('not-active');
			}

			setTimeout(() => {
				$(formHolder).removeClass(sentClass);
				$('.js-select-cf7 option:first-child').attr('disabled', true);
			}, delay);
			// remove value form upload field
			const inputUpload = $('.add-file');
			const inputValue = $('.add-file').val();
			if (inputUpload && inputValue !== '') {
				inputUpload.val('');
				inputUpload.parent().siblings('.js-custom-file').text('Upload resume');
				$('.js-custom-file-icon').removeClass('show-icon');
				inputUpload.parent().parent().parent().removeClass('has-value');
			}

			if (FormHelpers.thankYouUrls) {
				if ('mail_sent' === e.detail.status && FormHelpers.thankYouUrls[cf7Id]) {
					location = FormHelpers.thankYouUrls[cf7Id] ?? '';
				}
			}
		}, false);
	},
	// If user use Internet Explorer this is custom trigger for Thank you msg for CF7
	checkIfIE() {
		const url = window.location.href;
		if (url.indexOf(FormHelpers.strTriggerURL) > -1 && !$(FormHelpers.strForm).hasClass(FormHelpers.classInvalid)) {
			$(FormHelpers.strForm).parents(FormHelpers.strCF7Holder).addClass(FormHelpers.classSent);

			setTimeout(() => {
				$(FormHelpers.strCF7Holder).removeClass(FormHelpers.classSent);
			}, 5000);
		}
	},

	titlePlacement: () => {
		const wrapper = $('.wpcf7-form-control-wrap');
		$(wrapper).each((value, item) => {
			const getLabel = $(item).parent().parent().find('.js-form-placeholder').detach();
			$(item).append(getLabel);
		});
	},

	// Scroll down to mailchimp response on page load
	mailchimpScroll: () => {
		const blogPosts = $('#manage-ajax-response');

		const scroll = () => {
			const form = $('.mc4wp-form-submitted.mc4wp-form-error, .mc4wp-form-submitted.mc4wp-form-success');
			if (form.length && !$('.scroll-complete').length) {
				$('html,body').animate({
					scrollTop: form.offset().top - 50
				}, 500);
				$('body').addClass('scroll-complete');
			}
		};

		if (blogPosts.length) {
			$(document).ajaxStop(function() {
				scroll();
			});
		}

		if (!blogPosts.length) {
			scroll();
		}
	},

	customFile: function() {
		$('.js-custom-file').html('Upload resume <span>*</span>');
		$('.add-file').on('change', (e) => {
			const _self = $(e.currentTarget);
			const allowedFileTypes = ['doc', 'docx', 'pdf'];

			if (_self[0].files.length < 1) {
				_self.parent().siblings('.js-custom-file').html('Upload resume <span>*</span>');
				$('.js-custom-file-icon').removeClass('show-icon');
				_self.parent().parent().parent().removeClass('has-value');
			} else {
				const fileName = _self[0].files[0].name;
				const fileExtension = fileName.split('.').pop().toLowerCase();

				if (allowedFileTypes.includes(fileExtension)) {
					_self.parent().siblings('.js-custom-file').text(fileName);
					$('.js-custom-file-icon').addClass('show-icon');
					_self.parents('.input--file-wrap').find('label').css('opacity', '0');
					_self.parent().parent().parent().addClass('has-value');
					$('.notification-formats').removeClass('active');
				} else {
					$('.notification-formats').addClass('active');
					setTimeout(() => {
						$('.notification-formats').removeClass('active');
					}, 3000);
					_self.val('');
				}
			}
		});

		$('.js-custom-file-icon').on('click', function() {
			const _self = $(this);
			const fileInput = _self.closest('.input--file-wrap').find('.add-file');
			const customFile = _self.closest('.input--file-wrap').find('.js-custom-file');
			$('.js-custom-file-icon').removeClass('show-icon');
			fileInput.val('');
			customFile.text('Upload resume');
			$('.apply-form__file-wrap').removeClass('has-value');
		});

		$('.js-custom-file-icon').hover(
			function() {
				$('.js-custom-file').css('color', '#2940c2');
			},
			function() {
				$('.js-custom-file').css('color', '#2d2d2d');
			}
		);
	},

	checkCanvasMovement: () => {
		$($('.signature-821')[0]).on('mousedown touchstart', function() {
			$('.js-cf7-sign-error').removeClass('not-active');
		});
	},

	isCanvasEmpty: (canvas) => {
		const ctx = canvas.getContext('2d');
		const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

		for (let i = 0; i < imageData.data.length; i += 4) {
			// Check if any pixel is not transparent
			if (imageData.data[i + 3] !== 0) {
				return false; // Canvas is not empty
			}
		}

		return true; // Canvas is empty
	},

	clearCanvas: () => {
		const canvas = $('.signature-821')[0];

		$('#wpcf7_signature-821_clear').on('click', () => {
			// eslint-disable-next-line no-self-assign
			canvas.width = canvas.width;
			// eslint-disable-next-line no-self-assign
			canvas.height = canvas.height;
			$('.js-cf7-sign-error').addClass('not-active');
		});
	},

	errorScroll: () => {
		const topFields = $('.js-cf7-top-field.wpcf7-not-valid');
		const accordionFields = $('.js-accordion-item.active-error');

		if (topFields.length) {
			$('html,body').animate({
				scrollTop: topFields.offset().top - 130
			}, 500);
		} else {
			if (accordionFields.length) {
				$('html,body').animate({
					scrollTop: accordionFields.offset().top - 130
				}, 500);
			}
		}
	},

	/**
	 * Sets url for redirection after form submit
	 */
	getThankYouUrls: function() {
		$(document).ready(function() {
			const cf7Forms = $('input[name="_wpcf7"]');
			const urls = {};
			cf7Forms.each((index, form) => {
				const cf7Id = $(form).val();
				if (cf7Id) {
					const urlName = 'custom_thank_you_' + cf7Id;
					const thankYouElement = $('span[id="' + urlName + '"]');
					if (thankYouElement.length > 0) {
						urls[cf7Id] = thankYouElement.data('url').replace(/<\/?[^>]+(>|$)/g, '');
					}
				}
			});
			FormHelpers.thankYouUrls = urls;
		});
	},
};

export default FormHelpers;
